import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import './StepIndicator.css';
const StepIndicator = ({ currentStep, completedSteps }) => {
    const { t } = useTranslation();
    const steps = [
        {
            key: 'validate',
            titleKey: 'steps.validate',
            completed: completedSteps.includes('validate'),
            active: currentStep === 'validate',
        },
        {
            key: 'phone',
            titleKey: 'steps.phone',
            completed: completedSteps.includes('phone'),
            active: currentStep === 'phone',
        },
        {
            key: 'otp',
            titleKey: 'steps.otp',
            completed: completedSteps.includes('otp'),
            active: currentStep === 'otp',
        },
        {
            key: 'card',
            titleKey: 'steps.card',
            completed: completedSteps.includes('card'),
            active: currentStep === 'card',
        },
    ];
    return (_jsx("div", { className: "step-indicator", children: steps.map((step, index) => (_jsxs("div", { className: `step ${step.active ? 'active' : ''} ${step.completed ? 'completed' : ''}`, children: [_jsx("div", { className: "step-number", children: step.completed ? (_jsx("span", { className: "checkmark", children: "\u2713" })) : (_jsx("span", { children: index + 1 })) }), _jsx("div", { className: "step-label", children: t(step.titleKey) }), index < steps.length - 1 && _jsx("div", { className: "step-connector" })] }, step.key))) }));
};
export default StepIndicator;
